import { React, useEffect, useState } from "react";
import "./DailyTargets.css";
import {
  Col,
  Row,
  Spin,
  Form,
  Checkbox,
  InputNumber,
  Calendar,
} from "antd";
import ButtonComp from "../../ButtonComp/ButtonComp";
import { CheckCircleFilled } from "../../../Utils/imports";
import SyncMachine from "../SyncMachine/SyncMachine";
import moment from 'moment'

const DailyTargets = () => {
  let {
    plant = null,
    machine = null,
    line = null,
  } = JSON.parse(localStorage.getItem("current"));
  let machinearr = [machine?.machineName];
  const [selectedMachines, setState] = useState([]);
  const sync = async () => {};
  const [dict, setDict] = useState({});

  const dateCellRender = (date) => {

    let cell = dict[date.startOf('day').toDate()];
    let dateCell = (
      <span style={{ float: 'right', color: '#C4C4C4' }}>
        {date.toDate().getDate() < 10 ? '0' + date.toDate().getDate() : date.toDate().getDate()}
      </span>
    );
   let res =
      date.toDate() < moment().startOf('day') ? (
        <InputNumber style={{ float: 'right' }} min={0} value={cell ? cell : 0} disabled />
      ) : (
        <InputNumber
          style={{ float: 'right' }}
          min={0}
          value={cell ? cell : 0}
          onChange={(value) => changeInput(value, date)}
        />
      );
    return (
      <div>
        {dateCell}
        <br />
        {res}
      </div>
    );
  };
  const changeInput = (value, date) => {

    setDict((prevDict) => ({
      ...prevDict,
      [date.startOf('day').toDate()]: value,
    }));

    console.log(`Changed value for date ${date.toDate()}: ${value}`);

  };

  const handleSubmit = () => {
    console.log("Input values for each date:", dict);
  }
  
  return (
    <>
      <Row gutter={24} className="pt1">
        <Col span={12} className="dflex">
          <h1 className="pageHead">Daily Targets</h1>
        </Col>
        <Col span={12} style={{ paddingTop: "3px" }}>
          <div className="width100P dflex alignCenter justifyFE">
          <ButtonComp
  onClick={() => handleSubmit()}
  theme="blue"
  icon={<CheckCircleFilled />}
  text="Save"
/>
          </div>
        </Col>
      </Row>
      <Row className="width100P">
        <Col span={24}>
            <div className="boxBorderRad boxBorder pb10">
          <Calendar
            className="calendar boxBorderRad"
            dateFullCellRender={dateCellRender}
            fullscreen={false}
          />
          </div>
        </Col>
      </Row>
      <Row className="width100P">
        <Col span={24}>
          <Form>
            <SyncMachine
              machine={machine}
              //  canSync={(x) => canSync(x)}
              selectedMachines={selectedMachines}
              sync={sync}
              productionLine={line?.productionLine}
              changeMachines={(machines) => {
                setState(machines);
              }}
            />
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default DailyTargets;
